import { observer } from "mobx-react-lite"
import { useEffect } from "react"
import { useAuthStore, useRouterStore } from "../stores/StoreContext"
import { routes } from "./routes"

export const CallbackPage = observer(() => {
  const authStore = useAuthStore()
  const router = useRouterStore()

  useEffect(() => {
    const handleAuth = async () => {
      await authStore.handleCallback()
      if (authStore.isAuthenticated) {
        router.goTo(routes.home)
      }
    }
    handleAuth()
  }, [authStore.handleCallback, authStore.isAuthenticated, router.goTo])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 dark:border-white mx-auto mb-4" />
        <p className="text-lg">Completing authentication...</p>
        {authStore.error && <p className="text-red-500 mt-4">{authStore.error}</p>}
      </div>
    </div>
  )
})
